<template>
  <a-config-provider :locale="locale">
    <div class="root-app">
      <router-view />
      <mpm-task-console></mpm-task-console>
    </div>
  </a-config-provider>
</template>
<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import TaskConsole from '@/components/task-console/task-console'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        locale: zhCN,
        token: '',
      }
    },
    components: {
      'mpm-task-console': TaskConsole,
    },
  }
</script>
